<template>
  <div class="flex h-full justify-center">
    <!-- <toggle-button  :value="params.data.actionData.toggle"
            :color ="{checked: '#35C76F', unchecked: '#EA5455', disabled: '#CCCCCC'}"
            class="mt-3 mr-1"
            @change="handleChange"
            /> -->
    <!-- <vs-switch color="success" v-model="toggle" @change="handleChange" class="mr-2 mt-2" style="vertical-align: top !important;" /> -->
    <!-- <vs-button color="primary" type="border" icon-pack="feather" icon="icon-eye" class="mr-2" @click="hanldeViewSidebar"></vs-button> -->
    <vs-dropdown
      style="float: right; cursor: pointer"
      vs-custom-content
      vs-trigger-click
    >
      <vs-button
        color="primary"
        type="border"
        icon-pack="feather"
        icon="icon-more-vertical"
      ></vs-button>

      <vs-dropdown-menu>
        <!-- <vs-dropdown-item style="width: 100px;">&#43; Todo</vs-dropdown-item>
                    <vs-dropdown-item >&#43; Note</vs-dropdown-item>
                    <vs-dropdown-item >&#43; Meeting</vs-dropdown-item>
                    <vs-dropdown-item >&#43; Email</vs-dropdown-item> -->
        <vs-dropdown-item @click="editData">Edit</vs-dropdown-item>
        <!-- <vs-dropdown-item > Duplicate</vs-dropdown-item> -->
        <vs-dropdown-item @click="showPopUp(!showPopUpBool)">
          Delete</vs-dropdown-item
        >
        <vs-dropdown-item @click="handleChange" v-if="this.params.data.actionData.toggle">Deactivate</vs-dropdown-item>
        <vs-dropdown-item @click="handleChange" v-else>Activate</vs-dropdown-item>
        <vs-dropdown-item @click="hanldeViewSidebar"> Preview</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
    <vs-popup
      classContent="popup-example"
      title="Please Confirm"
      :active.sync="showPopUpBool"
    >
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="showPopUpBool = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import { Delete_Leads, activeDeactiveLeads } from "@/api/leads";
import { mapActions } from "vuex";
// import { ToggleButton } from 'vue-js-toggle-button'
export default {
  name: "CellRendererActions",
  // components: {
  //   ToggleButton
  // },
  props: {
    // localValue: actionData,
  },
  mounted() {
    this.action = this.params.data.actionData;
    // this.toggle = this.params.data.actionData.toggle
  },
  data() {
    return {
      action: {},
      showPopUpBool: false,
      toggle: false
    };
  },
  methods: {
    ...mapActions([
      "SET_DELETE_ID",
      "SET_VIEW_LEADS_SIDEBAR",
      "SET_VIEW_LEADS_SIDEBAR_DATA",
      "SET_LEADS_TOGGLE_DATA",
    ]),
    async handleChange () {
      this.params.data.actionData.toggle = !this.params.data.actionData.toggle
      this.params.data.is_active = this.params.data.actionData.toggle ? 1 : 0
      try {
        const leads_id = this.params.data.leads_id
        const payload = {
          leads_id,
          type: this.params.data.actionData.toggle ? 1 : 0
        }
        activeDeactiveLeads(payload)
        const storePayload = {
          row_details: this.params.data,
          toggle: this.params.data.actionData.toggle
        }
        this.SET_LEADS_TOGGLE_DATA(storePayload)
        const msg = this.params.data.actionData.toggle ? 'Lead activated successfully' : 'Lead deactivated successfully'
        this.$vs.notify({
          title: 'Success',
          text: msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {

        this.$vs.notify({
          title: 'Warning',
          text: e,
          ...this.warnProp()
        })
      }
    },
    // async handleChange () {
    //
    //   try {
    //     const leads_id = this.params.data.leads_id
    //     const payload = {
    //       leads_id,
    //       type: this.params.data.actionData.toggle ? 0 : 1
    //     }
    //     const data = activeDeactiveLeads(payload)
    //
    //     const storePayload = {
    //       row_details: this.params.data,
    //       toggle: !this.params.data.actionData.toggle
    //     }
    //     this.SET_LEADS_TOGGLE_DATA(storePayload)
    //     this.$vs.notify({
    //       title: 'Success',
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'success'
    //     })
    //   } catch (e) {
    //
    //     this.$vs.notify({
    //       title: 'Warning',
    //       text: e,
    //       ...this.warnProp()
    //     })
    //   }
    // },
    showPopUp() {
      if (this.params.data.actionData.toggle) {
        this.$vs.notify({
          title: "Warning",
          text: "Can\'t delete non actionable row",
          ...this.warnProp(),
        });
      } else {
        this.showPopUpBool = true;
      }
    },
    async handleDelete() {
      const deleting_id = this.params.data.leads_id;
      const payload = {
        leads_id: [deleting_id],
        customer_id: this.$store.getters.customerId,
      };

      try {
        const data = await Delete_Leads(payload);
        this.SET_DELETE_ID(deleting_id);

        this.showPopUpBool = false;

        this.$vs.notify({
          title: "Lead deteled",
          text: "Lead deleted successfully",
          ...this.successProp(),
        });
      } catch (error) {}
    },
    editData() {
      if (this.params.data.is_active === '0') {
        this.$vs.notify({
          title: "Warning",
          text: "Can\'t edit non actionable row",
          ...this.warnProp(),
        });
        return false
      }
      
      this.$router.push({
        name: "lead-edit",
        params: { leadId: this.params.data.leads_id },
      });
    },
    hanldeViewSidebar() {
      const viewbutton = true;
      this.SET_VIEW_LEADS_SIDEBAR(viewbutton);
      this.SET_VIEW_LEADS_SIDEBAR_DATA(this.params.data);
    },
  },
};
</script>
